import { Trans, useTranslation } from "react-i18next";
import dompurify from "dompurify";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import Button from "../../components/shared/button/component";

const RBForgetPassword = ({
  emailError,
  emailErrorMsg,
  emailSuccess,
  email,
  onemailChange,
  onSubmitClickHandler,
  buttonText,
}) => {
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;
  return (
    <>
      <Helmet>
        <meta name="description" content={t("forgot_password.rb.description_meta")}/>
        <title>{t("page_title.forgot_password")}</title>
      </Helmet>
      <section className="main-content">
        <div className="container mx-auto">
          <div className="form-wrap">
            <div className="form-container">
              <hgroup className="text-center user-page">
                <h1 className="main-headline font-bold uppercase text-2xl md:text-xl lg:text-xl">
                  {t("forgot_password.headline")}
                </h1>
                <p className="sub-paragraph mb-6 text-base md:text-sm lg:text-sm">
                  {t("forgot_password.content")}
                </p>
              </hgroup>
              <div className="form-group">
                <div className="form-text mb-2">
                  {emailError && (
                    <p
                      key="pswrdErr"
                      role={alert}
                      className="alert error border bg-orange-50 border-orange-500 text-[#fe8c26] px-2 py-1"
                    >
                      <h2 className=" font-bold">
                        {" "}
                        {t("forgot_password.forget_alert_text")}
                      </h2>
                      <br />
                      <li className="text-xs"> {emailErrorMsg}</li>
                    </p>
                  )}

                  {emailSuccess && (
                    <p
                      key="pswrdErr"
                      role={alert}
                      className="alert error border bg-orange-50 border-orange-500 text-[#fe8c26] px-2 pb-2 text-sm"
                    >
                      <h4> {t("forgot_password.forget_success_alert")}</h4>
                    </p>
                  )}
                </div>
                <InputText
                  showLabel={false}
                  required="required"
                  id="email"
                  type="email"
                  className="border border-gray-300 rounded-sm  px-3 py-2 md:py-1 lg:py-1 border mb-4"
                  name="email"
                  value={email}
                  maxLength={100}
                  onChange={onemailChange}
                  placeholder={t("forgot_password.placeholder_email")}
                />
              </div>

              <div className="align-center fbn  fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2.5 md:p-0 lg:p-0 text-center w-full z-50">
                <Button
                  isLoading={false}
                  disabled={false}
                  type="submit"
                  className="bg-[#fe8c26] hover:bg-[#f07201] px-10 transition-all duration-400 ease-out delay-100 active:bg-blue-500 text-white rounded font-semibold py-3 w-full uppercase"
                  onClick={onSubmitClickHandler}
                  ctaText={buttonText}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default RBForgetPassword;
